import React from "react";

interface GlassPanelProps {
  title?: string;
  badge?: string;
  badgeVariant?: "ok" | "warn" | "bad" | "info" | "";
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

export function GlassPanel({
  title,
  badge,
  badgeVariant = "",
  className = "",
  style,
  children,
}: GlassPanelProps) {
  return (
    <section className={`glass-panel ${className}`} style={style}>
      {title ? (
        <div className="panel-header">
          <h3>{title}</h3>
          {badge ? <span className={`badge ${badgeVariant}`}>{badge}</span> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
